<template>
   <status_dashboard_adv-component>
  <div class="animated fadeIn">

    <b-row>
      <b-col lg="12">
      <!--  <b-breadcrumb :items="breadcrumbs"/>   -->  
       <b-card header-tag="header" footer-tag="footer">
      
        <b-row class="mb-4">          
              <div id="overlay" >
             <div class="loader"></div>
           </div>
           
        
           <b-col sm="12" class="text-right">
            <b-button v-if="this.totalRows >0" type="submit" variant="primary" size="md" @click="downloadCSV">Download </b-button>
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col>        
        </b-row>

              <b-table show-empty stacked="md" style="text-align: left" :items="records"   :fields="fields"   :current-page="currentPage"  :per-page="perPage" :bordered="bordered"  :filter="filter"    thead-class="hidden_header"  @filtered="onFiltered"     :busy="isBusy" >
          
          <template slot="top-row">
             <td class="totalback" v-for="record in items" ><b>{{record}}</b></td>
          
          
   
    </template>
          
         
                      
                      <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>     
                  </b-table> 
                    <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
           <!--  <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              >
            </b-pagination> -->
             <paginate
   
    :page-count="noofpages"
    :page-range="10"
    :margin-pages="2"
    :click-handler="clickCallback"
    :prev-text="'Prev'"
    :next-text="'Next'"
    :container-class="'pagination'"
    :page-class="'page-item'">
  </paginate>
          </b-col> 
      
      


       <!--  <div class="col-md-12">
            <div class="panel panel-default">
               
                <div class="panel-body">
                    <div class="table-responsive" >

                      <table id="dtBasicExample" class="table table-striped table-bordered table-sm" cellspacing="0" >
                          <tbody>
     
                            <th  class="table-active" v-for="item in items">{{item}}</th>
                            
                            <tr v-for="record in records">
                              <td v-for="(item, index) in items">{{record[index]}}</td>
                              
                            </tr>
                            


                          </tbody>
                      </table>

                    </div>
                    <div class="table-responsive" >
                        <table  v-if="totalRows <=0" id="dtBasicExample" class="text-center table table-striped table-bordered table-sm" cellspacing="0" >
                            <tr><td>No records available to Display.</td></tr>
                        </table>

                       

                         
                    </div>

                     
                </div>
            </div>

        </div> -->

       
       </b-card>
        
      </b-col>
    </b-row><!--/.row-->

  </div>
   </status_dashboard_adv-component>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
import { EventBus } from "./event-bus.js";
export default {
  mounted() {  
   // Listen for the 'clicked-event' and its payload.  
      EventBus.$on("clicked-event", Count=> {  
  
  this.showlistingdetails(this.pageNum); 
      });  
   }  ,
  data: function() {
    return {
      name: 'codReports',
      data: [],
       records:[],
      items:[],
      fields:[],
      isBusy: false,
    
      // fields: [
      //     { key: 'daname', label: 'Delivery Agent', sortable: true, sortDirection: 'desc' },
      //      { key: 'codcollectable', label: 'COD Collected', sortable: true}
      //     //   { key: 'todaypendingamount', label: 'Cod Pending-previous days', sortable: true},
      //     //     { key: 'totalpendingamount', label: 'Total Pending Cod', sortable: true}
          
      // ],
      bordered: true,
       disabled: '',
      totalRows: 0,
      currentPage: 1,
      perPage:  20,
      pageNum:1,
      noofpages:'',
      pageOptions: [5, 10, 15],
      sortBy: true,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      selectDateTo: new Date(),
       selectDateFrom: new Date(),
    }
  },
  computed: {
    sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
  },
  created: function () {
    this.showlistingdetails(this.pageNum)
  },

  methods: {
      // info(item, index, button) {
      //   this.infoModal.title = `Row index: ${index}`
      //   this.infoModal.content = JSON.stringify(item, null, 2)
      //   this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      // },
      // resetInfoModal() {
      //   this.infoModal.title = ''
      //   this.infoModal.content = ''
      // },
      // onFiltered(filteredItems) {
      //   // Trigger pagination to update the number of buttons/pages due to filtering
      //   this.totalRows = filteredItems.length
      //   this.currentPage = 1
      // },
    
    showlistingdetails: function (pagee) {
       var userdata = localStorage.getItem('userData');
       var userInfo = JSON.parse(userdata);
         this.isBusy = true;
      // console.log("Hello:::::::");
      // alert(" i m in dashboard");
       let fromdate = localStorage.getItem('fromdate');
       let todate = localStorage.getItem('todate');
       var deliveryagentid = JSON.parse(localStorage.getItem("deliveryagentidarr"));
       var locationid = JSON.parse(localStorage.getItem("locationarr"));
        var zoneid = JSON.parse(localStorage.getItem("zonearr"));
       var vendorid = JSON.parse(localStorage.getItem("vendorarr"));
       var orderflowid = JSON.parse(localStorage.getItem("orderflowarr"));

       //let vendorid = localStorage.getItem('vendorid');

       //let orderflow = localStorage.getItem('orderflow');
       var shipmentstatus = JSON.parse(localStorage.getItem("statusarr"));
      var shipmenttype = localStorage.getItem('statustypearr');
       //let shipmentstatus = localStorage.getItem('shipmentstatus');
      

       // console.log(fromdate);
        // console.log(todate);
      

    
      const customerGetobj = {
       
          fromdate:`${fromdate}`, 
          todate:`${todate}`,
          deliveryagentid:deliveryagentid,
          //pickuplocationname:locationid,
           zonename:zoneid,

          orderflow:orderflowid,
          vendor:vendorid,
          pickuptype:shipmenttype,
          status:shipmentstatus,
          limit:"20",
          page_no:pagee,
           hub_id:`${userInfo.pickuplocationmasterid}`,
      
 
         
            
      }
      // console.log("mukesh"+this.customerGetobj);
      // console.log(this.customerGetobj);
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/statusreportlisting`, customerGetobj)
        .then((result) => {
          if (result.body.returnmsg === 'successful') {
          
            this.isBusy = !this.isBusy
        
           
        this.totalRows = result.body.returnvalue[1].totalrecords[0].count
        
            console.log("heeeeeee"+this.totalRows);
            this.items  = result.body.returnvalue[0].StatusReportListingInfo[0].Heading;
            
            //this.items1  = result.body.returnvalue[0].Heading.length;
            //console.log("pppppppp"+this.items1);
            this.records  = result.body.returnvalue[0].StatusReportListingInfo[0].Records;
               // console.log(this.records);
               this.noofpages=parseInt(this.totalRows)/20;
              this.noofpages=Math.ceil( this.noofpages);
            //return false;
          
            //document.getElementById('refreshId').className = 'fa fa-refresh'
          } else {
            this.isBusy = !this.isBusy
             this.items=[];
               this.records=[];
            this.totalRows = 0
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
     clickCallback (pageNum)
       {
      //   alert(" i m in pagination task");
      // alert(pageNum)
      this.showlistingdetails(pageNum);
    },


downloadCSV: function() {
   document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata) 
 // alert(" i m i  Download");
 // alert(pagee);
 let fromdate = localStorage.getItem('fromdate');
       let todate = localStorage.getItem('todate');
       var deliveryagentid = JSON.parse(localStorage.getItem("deliveryagentidarr"));
       //var locationid = JSON.parse(localStorage.getItem("locationarr"));
       var zoneid = JSON.parse(localStorage.getItem("zonearr"));
        //let zoneid = localStorage.getItem("zonearr");

       var vendorid = JSON.parse(localStorage.getItem("vendorarr"));
       var orderflowid = JSON.parse(localStorage.getItem("orderflowarr"));

       var shipmentstatus = JSON.parse(localStorage.getItem("statusarr"));
       var shipmenttype = localStorage.getItem('statustypearr');
      
      var deliveryagentid = JSON.parse(localStorage.getItem("deliveryagentidarr"));
     
     
      
          var csvObj = {
          //    limit:"20",
          // page_no:pagee,
            fromdate:`${fromdate}`, 
          todate:`${todate}`,
          deliveryagentid:deliveryagentid,
          //pickuplocationname:locationid,
          zonename:zoneid,
          orderflow:orderflowid,
          vendor:vendorid,
          pickuptype:shipmenttype,
          status:shipmentstatus,
          sysusermasterid:`${userInfo.sysusermasterid}`, 
          hub_id:`${userInfo.pickuplocationmasterid}`, 
      
            
           
          };
         
         
      

      // console.log(csvObj);
     
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
      if(todate< fromdate){
        // alert('To date need to be grater than From date');
          this.$fire({
                  text:"To date need to be grater than From date",
                  type: "warning",
                  timer: 30000
                }); 
          
      }
      //var r = Math.random().toString(36).substring(3);
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/statusreportlistingcsv_advanced`,csvObj)
        .then(result => {
         // console.log(result.url);
          document.getElementById("overlay").style.display = "none";
          if(result.body=="success")
         {
         // alert("Please Check Ur Mail For Downlod Link")
           this.$fire({
                  text:"Please Check Ur Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                }); 
       }
       else
       {
        // alert("Can not Download");
          this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                }); 
       }
        //window.location.href =result.url;
        });
        
    },
// downloadCSV: function() {
      
//  // alert(" i m i  Download");
//  // alert(pagee);
//  let fromdate = localStorage.getItem('fromdate');
//        let todate = localStorage.getItem('todate');
//        var deliveryagentid = JSON.parse(localStorage.getItem("deliveryagentidarr"));
//        //var locationid = JSON.parse(localStorage.getItem("locationarr"));
//        var zoneid = JSON.parse(localStorage.getItem("zonearr"));
//         //let zoneid = localStorage.getItem("zonearr");

//        var vendorid = JSON.parse(localStorage.getItem("vendorarr"));
//        var orderflowid = JSON.parse(localStorage.getItem("orderflowarr"));

//        var shipmentstatus = JSON.parse(localStorage.getItem("statusarr"));
//        var shipmenttype = localStorage.getItem('statustypearr');
      
//       var deliveryagentid = JSON.parse(localStorage.getItem("deliveryagentidarr"));
     
     
      
//           var csvObj = {
//           //    limit:"20",
//           // page_no:pagee,
//             fromdate:`${fromdate}`, 
//           todate:`${todate}`,
//           deliveryagentid:deliveryagentid,
//           //pickuplocationname:locationid,
//           zonename:zoneid,
//           orderflow:orderflowid,
//           vendor:vendorid,
//           pickuptype:shipmenttype,
//           status:shipmentstatus,
            
           
//           };
         
         
      

//       // console.log(csvObj);
     
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// // console.log(queryString);
//       if(todate< fromdate){
//         alert('To date need to be grater than From date');
          
//       }
//       //var r = Math.random().toString(36).substring(3);
// this.$http.get(`${CONSTANTS.MISREPORT_API_URL}/statusreportlistingcsv`+queryString)
//         .then(result => {
//          // console.log(result.url);
//         window.location.href =result.url;
//         });
        
//     },
    // Todate: function()
    // {
    //   this.model1="ture";
    // },

    
    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },


    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  }
}
</script>
<style type="text/css">
 .totalback
 {
  background: #c8ced3 !important;
   border-right: 1px solid grey !important;
    width: 150px !important;


  }

  .hidden_header {
   
  display: none;
  

}
.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color .3s;
  /* border: 1px solid #ddd;*/ /* Gray */
}

/* Style the active/current link */
/*.pagination a.active {
   
  
}*/
.page-item.active {
  background-color: #87CEEB;
    color: white;
}
/* Add a grey background color on mouse-over */
.pagination a:hover:not(.active) {background-color: #ddd;}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
   
  

</style>
